import React, { useState, useEffect } from "react";
import styles from "./profile.module.scss";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ProfileForm from "../../features/ProfileForm";
import { Box, SxProps } from "@mui/material";
import { Padding } from "@mui/icons-material";
// import { useTitle } from "../../context/TitleContextType";
// import UpdatePassword from "../../features/UpdatePassword";

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
  sx?: SxProps;  
}


function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, sx, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Profile() {
  // const { setTitle } = useTitle();
    
      // useEffect(() => {
      //   setTitle("Profil"); 
      // }, []);

  const [value, setValue] = useState(0);
 



  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className={styles.wrapper}>
       <div className={styles.wrapperMain}>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
           value={value} 
           onChange={handleChange} 
           TabIndicatorProps={{
            style: { display: "none" }, 
          }}
           aria-label="basic tabs example">
            <Tab  sx={{
              fontSize: "14px",
              fontWeight: "500",
      color:  "#7688DB", 
      "&.Mui-selected": {
        color: "#22337F", 
        borderBottom: "3px solid #22337F",
      },
    
    }} label="Profil bearbeiten" {...a11yProps(0)} />
            <Tab sx={{
               fontSize: "14px",
               fontWeight: "500",
      color: "#7688DB", 
      "&.Mui-selected": {
        color: "#22337F", 
        borderBottom: "3px solid #22337F",
      },
    }} label="Einstellungen" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel sx={{padding: "0px"}} value={value} index={0}>
         
            <ProfileForm />
        
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          {/* <UpdatePassword/> */}
        </CustomTabPanel>
      </Box>
      </div>
    </div>
  );
}

export default Profile;
